var EditColumnSidepanelModule = /** @class */ (function () {
    function EditColumnSidepanelModule() {
    }
    return EditColumnSidepanelModule;
}());
export { EditColumnSidepanelModule };
